module.exports = __webpack_public_path__ + "img/title_2.40e6c167.png";